// extracted by mini-css-extract-plugin
export default {"hideTooltip":"t--z","fadeIn":"u--z","delay":"v--z","recommendedSizeTooltip":"w--z"};